<form #LoginForm="ngForm">
  <nb-card *ngIf="page==1" [nbSpinner]="loadingSpiner" nbSpinnerStatus="success" nbSpinnerSize="giant" >
  
    <nb-card-body>
      <h1 id="title" class="title">登入</h1>
      
      <div class="form-control-group">
        <nb-radio-group name="loginType" [(value)]="user.loginType" class="d-flex justify-content-center">
          <nb-radio value="2" ><span class="text-secondary">門市</span> </nb-radio>
          <nb-radio value="1" ><span class="text-secondary">總部</span> </nb-radio>         
        </nb-radio-group>
      </div>


      <div class="form-control-group" *ngIf="user.loginType==2">
        <label class="label" for="StoreNumber">門市編號:</label>
        <!-- 預設 -->
        <input nbInput fullWidth name="StoreNumber" [(ngModel)]="user.StoreNumber">
      </div>
      
      <div class="form-control-group">
        <label class="label" for="Cellphone">帳號:</label>
        <input nbInput fullWidth name="Cellphone" [(ngModel)]="user.Cellphone">
      </div>

      <div class="form-control-group">
        <label class="label" for="password">密碼:</label>
        <input nbInput fullWidth name="password" [(ngModel)]="user.Password" type="password">
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton fullWidth status="success" (click)="goto_login()" 
        [disabled]="LoginForm.invalid">
        登入
      </button>
    </nb-card-footer>

  </nb-card>
</form>



<nb-card *ngIf="page==2" [nbSpinner]="loadingSpiner" nbSpinnerStatus="success" nbSpinnerSize="giant" >
  <nb-card-body>
    <span class="float-right" (click)="page=1">
      <nb-icon nbSuffix icon="close-outline" pack="eva"></nb-icon>
    </span>
    <h1 id="title" class="title">
      選擇公司
    </h1>
   
    <nb-form-field>
      <input name="SearchStore"  nbInput fullWidth placeholder="查詢公司名稱"
      [(ngModel)]="SearchStore"
      >
      <nb-icon nbSuffix icon="search" pack="eva"></nb-icon>
    </nb-form-field>


    <nb-list style="height: 350px;" class="mt-4">
      <nb-list-item class="p-0" *ngFor="let com of comList | keyword:'CompanyName':SearchStore:null:false">
        <div class="itemDIV p-3 w-100" (click)="login(com.CompanyNumber)">{{com.CompanyName}}</div>
      </nb-list-item>
    </nb-list>





    
   
  </nb-card-body>
 
</nb-card>